/* TEST-006 — P02 price elasticity router.
 *
 * GMC EXCLUSION (added 2026-05-13): visitors arriving with ?srsltid= (free
 * Google Shopping) or ?gclid= (Google Ads — Shopping/PMax/Search) are
 * forced to control to avoid PDP-vs-feed price mismatch and the GMC
 * suspension risk. URL overrides (?cl_price_v=...) still bypass this so
 * QA preview links work. See isGoogleShoppingTraffic().
 *
 * Arm A: Subtract $100 from every visible price node — inline price block,
 *        sticky price block, AND the ATC button's price ([data-cta-price]).
 *        Inline price block shows strikethrough original + new price; the
 *        ATC button keeps a single (discounted) number to stay compact.
 *        Re-applies on variant changes via MutationObserver so when the user
 *        toggles "with bag" / shaft material / etc., the discount math stays
 *        correct against whatever the page just rendered.
 * Arm B: Same display mechanism, gated on the opt-in checkbox.
 * Control: no change.
 *
 * Discount application (Option A — Shopify discount code + cookie):
 *   When TEST_MODE='live' AND shouldShowDiscount() is true, a silent
 *   fetch to /discount/CL-P02-100OFF sets the discount_code cookie. The
 *   cookie persists for the session, so when the user ATCs and proceeds
 *   to checkout, Shopify applies -$100 to the P02 line item automatically.
 *   For arm B unchecking, we best-effort clear via fetch /discount/null.
 *
 *   SMOKE MODE: no discount fetch by default — display swap only.
 *   Opt-in: append &cl_price_apply=1 to the URL to fire the real discount
 *   fetch in smoke mode (mirrors the existing &cl_price_track=1 opt-in for
 *   exposure events). For QA validation of the cart-side wiring without
 *   flipping TEST_MODE to live. Anonymous URL-override previews without
 *   the opt-in stay UI-only.
 *
 *   The Shopify discount code (CL-P02-100OFF) must exist with:
 *     - P02 product restriction
 *     - -$100 fixed amount
 *     - One use per customer
 *     - 14-day active window
 *   (Manual create — see deploy doc.)
 */
(function(){
  'use strict';
  var TEST_ID='pdp_p02_price_elasticity', COOKIE='cl_price_v4', PARAM='cl_price_v', TTL=14;
  // REACTIVATED 2026-06-01 by collin@stix.golf at 50/25/25. History: launched
  // 2026-05-13 at 80/10/10, re-weighted to 70/10/20 on 2026-05-29, paused
  // 2026-05-19 (SPLIT=100% control) for the 5/20 promo. 50/25/25 restores
  // a/b symmetry for the spec's "a vs b CVR delta" secondary metric and reads
  // both treatments in ~5–7 days. COOKIE bumped v3→v4 to re-bucket cleanly.
  // Pause again by setting SPLIT back to [{a:'control',w:100}].
  var SPLIT=[{a:'control',w:50},{a:'a',w:25},{a:'b',w:25}];
  var VALID={control:1,a:1,b:1};
  var TEST_MODE='live';
  // ─── Metafield override ─── mirrors stix-sticky-atc-test.js + snippets/cro-config-global.liquid.
  // Read shop.metafields.cro.test_config[TEST_ID] from window.STIX_CRO_CONFIG (emitted page-global).
  // If present, REPLACE the hardcoded SPLIT + VALID above so weight/status changes via
  // Scripts/cro_config.py take effect on next page load WITHOUT a theme deploy. Falls back to the
  // hardcoded defaults when the global is missing (dev/preview). Closes the metafield-doesn't-drive-JS
  // gap for price_elasticity (the last hardcoded router, fixed 2026-06-10).
  try {
    var __mf = window.STIX_CRO_CONFIG && window.STIX_CRO_CONFIG[TEST_ID];
    if (__mf && __mf.variants && __mf.variants.length) {
      SPLIT = __mf.variants.map(function(v){ return {a: v.label, w: v.weight}; });
      VALID = {};
      __mf.variants.forEach(function(v){ VALID[v.label] = 1; });
      if (__mf.status === 'paused' || __mf.status === 'reverted') TEST_MODE = 'smoke';
      window.STIX_TEST_SOURCE = (window.STIX_TEST_SOURCE||{}); window.STIX_TEST_SOURCE[TEST_ID] = 'metafield';
    } else {
      window.STIX_TEST_SOURCE = (window.STIX_TEST_SOURCE||{}); window.STIX_TEST_SOURCE[TEST_ID] = 'hardcoded';
    }
  } catch(e){}
  var DISCOUNT_AMOUNT = 100; // dollars off (display)
  var DISCOUNT_CODE   = 'CL-P02-100OFF'; // Shopify discount code (real money)

  var PRICE_SELECTORS = '[data-product-price], [data-cta-price]';
  var _state = { arm: null, checked: false, lock: false };

  function gc(n){var m=document.cookie.match(new RegExp('(?:^|;\\s*)'+n+'=([^;]*)'));return m?decodeURIComponent(m[1]):null;}
  function sc(n,v,d){var x=new Date();x.setTime(x.getTime()+d*86400000);document.cookie=n+'='+encodeURIComponent(v)+'; expires='+x.toUTCString()+'; path=/; SameSite=Lax';}
  function ovr(){try{var p=new URLSearchParams(location.search).get(PARAM);if(!p) return null; p=p.toLowerCase(); return VALID[p]?p:null;}catch(e){return null;}}
  function pick(){var r=Math.random()*100,c=0;for(var i=0;i<SPLIT.length;i++){c+=SPLIT[i].w;if(r<c)return SPLIT[i].a;}return SPLIT[0].a;}
  function isBot(){return /bot|crawl|spider|slurp|duckduckbot|baiduspider|yandex|bingpreview|facebookexternalhit|embedly|lighthouse|headlesschrome/i.test(navigator.userAgent||'');}
  // Google Shopping / Google Ads exclusion. The visible price change on this
  // test is a GMC price-mismatch suspension risk for any visitor who lands
  // via a Google surface that displays the feed price (free Shopping
  // listings via srsltid; Shopping/PMax ads via gclid). gclid also covers
  // Search Ads — we accept that sample loss because the asymmetry favors
  // safety. Note: Storebot-Google + Googlebot are already caught by
  // isBot(), so the automated feed-crawl path is already control.
  function isGoogleShoppingTraffic(){
    try {
      var q = new URLSearchParams(location.search);
      if(q.get('srsltid')) return true;
      if(q.get('gclid'))   return true;
    } catch (e) {}
    return false;
  }

  function init(){
    if(!document.querySelector('[data-cl-price-router]')) return;
    var arm=ovr(), fromUrl=!!arm;
    if(!arm){
      if(TEST_MODE==='smoke') arm='control';
      else if(isBot()) arm='control';
      else if(isGoogleShoppingTraffic()) arm='control'; // GMC price-mismatch guard
      else{arm=gc(COOKIE); if(!arm||!VALID[arm]){arm=pick(); sc(COOKIE,arm,TTL);}}
    } else { sc(COOKIE,arm,TTL); }
    _state.arm = arm;
    window.STIX_TEST=window.STIX_TEST||{}; window.STIX_TEST[TEST_ID]=arm;
    if (typeof window.stixCroExpose === "function") { window.stixCroExpose(TEST_ID, arm, { page_type: "pdp" }); }
    document.documentElement.setAttribute('data-cl-price-arm',arm);
    apply(arm);
    var track=(new URLSearchParams(location.search).get('cl_price_track')==='1');
    if(TEST_MODE==='live'||(fromUrl&&track)) fire(arm);
  }

  function apply(arm){
    if(arm==='a'){
      installPriceObserver();
      applyPriceState();
      startGuard();
    } else if(arm==='b'){
      var optin=document.querySelector('[data-cl-price-optin]');
      if(optin){
        function place(){
          var atc=document.querySelector('[data-cta-wrapper]');
          if(!atc) return false;
          atc.parentNode.insertBefore(optin, atc);
          optin.hidden=false; optin.removeAttribute('hidden');
          return true;
        }
        if(!place()){
          var tries=0, iv=setInterval(function(){ tries++; if(place()||tries>40) clearInterval(iv); },120);
        }
      }
      wireOptinForm();
      installPriceObserver();
      startGuard();
      // Don't apply until user opts in.
    }
  }

  // Compute the "discounted" price string by subtracting DISCOUNT_AMOUNT
  // from any $X,XXX or $X pattern found in `text`. For the main price node
  // we render strikethrough(original) + discounted; for the ATC button
  // ([data-cta-price]) we just swap the number to keep the button compact.
  function discountText(text, withStrike){
    var m = text.match(/\$([\d,]+)(\.\d{2})?/);
    if(!m) return null;
    var num = parseInt(m[1].replace(/,/g,''), 10);
    if(isNaN(num)) return null;
    var discounted = Math.max(0, num - DISCOUNT_AMOUNT);
    var formatted = '$' + discounted.toLocaleString('en-US') + (m[2] || '');
    if(!withStrike) return text.replace(m[0], formatted);
    var strike = '<s class="cl-price-strike" style="color:#9a9a9a;font-weight:400;margin-right:0.4em;text-decoration:line-through;">' + m[0] + '</s>';
    return text.replace(m[0], strike + formatted);
  }

  // Cache original HTML on every price node (call after any page-driven
  // mutation, before we overwrite, so toggle-off restores correctly).
  function cacheOriginals(){
    document.querySelectorAll(PRICE_SELECTORS).forEach(function(n){
      n.setAttribute('data-cl-price-orig', n.innerHTML);
    });
  }
  // Set every price node to the discounted text (computed from its current
  // cached original). Idempotent — running twice produces the same result.
  function setDiscounted(){
    _state.lock = true;
    document.querySelectorAll(PRICE_SELECTORS).forEach(function(n){
      if(!n.hasAttribute('data-cl-price-orig')){
        n.setAttribute('data-cl-price-orig', n.innerHTML);
      }
      var orig = n.getAttribute('data-cl-price-orig');
      // Strike-through only on the main price block. Keep CTA button compact.
      var withStrike = n.hasAttribute('data-product-price');
      var swapped = discountText(orig, withStrike);
      if(swapped) n.innerHTML = swapped;
    });
    setTimeout(function(){ _state.lock = false; }, 50);
  }
  function setOriginal(){
    _state.lock = true;
    document.querySelectorAll(PRICE_SELECTORS).forEach(function(n){
      if(n.hasAttribute('data-cl-price-orig')){
        n.innerHTML = n.getAttribute('data-cl-price-orig');
      }
    });
    setTimeout(function(){ _state.lock = false; }, 50);
  }

  function shouldShowDiscount(){
    if(_state.arm === 'a') return true;
    if(_state.arm === 'b') return _state.checked;
    return false;
  }
  function applyPriceState(){
    if(shouldShowDiscount()){ setDiscounted(); applyShopifyDiscount(); }
    else { setOriginal(); removeShopifyDiscount(); }
  }
  // Belt-and-suspenders: re-apply state every 350ms whenever discount should
  // be visible. Catches edge cases where another script (variant handler,
  // shop-pay refresh, etc.) overwrites our swap on [data-cta-price].
  function startGuard(){
    if(window._cl_price_guard_started) return;
    window._cl_price_guard_started = true;
    setInterval(function(){
      if(shouldShowDiscount()) setDiscounted();
    }, 350);
  }

  // Silently fetch /discount/<CODE> to set the discount_code cookie. When the
  // user proceeds to checkout, Shopify applies -$100 to the P02 line item.
  // SMOKE MODE normally stays UI-only — but ?cl_price_apply=1 opts in to the
  // real fetch so QA can validate the cart-side discount without flipping
  // TEST_MODE to live. Mirrors the existing ?cl_price_track=1 opt-in for
  // exposure events. Default visitors land on smoke + UI-only.
  function applyShopifyDiscount(){
    var optInApply = (function(){
      try { return new URLSearchParams(location.search).get('cl_price_apply') === '1'; }
      catch(e){ return false; }
    })();
    if(TEST_MODE !== 'live' && !optInApply) return;
    if(window._cl_discount_applied) return; // idempotent per session
    window._cl_discount_applied = true;
    try {
      fetch('/discount/' + encodeURIComponent(DISCOUNT_CODE), {
        method: 'GET',
        credentials: 'same-origin',
        redirect: 'follow',
        cache: 'no-store'
      }).catch(function(){});
    } catch (e) {}
  }
  // Best-effort discount-clear when arm B is toggled off. Shopify doesn't
  // have a one-shot "remove cookie" endpoint, so we clear via cart.js.
  function removeShopifyDiscount(){
    var optInApply = (function(){
      try { return new URLSearchParams(location.search).get('cl_price_apply') === '1'; }
      catch(e){ return false; }
    })();
    if(TEST_MODE !== 'live' && !optInApply) return;
    if(!window._cl_discount_applied) return;
    window._cl_discount_applied = false;
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'discount=',
        credentials: 'same-origin',
        keepalive: true
      }).catch(function(){});
    } catch (e) {}
  }

  // MutationObserver: when the page rewrites a price node (variant change),
  // update our cached original and reapply discount if active. Lock flag
  // prevents infinite loops from our own mutations.
  function installPriceObserver(){
    if(window._cl_price_observer_installed) return;
    window._cl_price_observer_installed = true;
    function attempt(){
      var nodes = document.querySelectorAll(PRICE_SELECTORS);
      if(!nodes.length) return false;
      var obs = new MutationObserver(function(){
        if(_state.lock) return;
        // Page changed the price (variant switched, etc). Refresh cache
        // from current DOM, then re-apply our state.
        cacheOriginals();
        applyPriceState();
      });
      nodes.forEach(function(n){
        obs.observe(n, { childList:true, characterData:true, subtree:true });
      });
      // Prime the cache on first install.
      cacheOriginals();
      return true;
    }
    if(attempt()) return;
    var tries=0, iv=setInterval(function(){ tries++; if(attempt()||tries>40) clearInterval(iv); },120);
  }

  function wireOptinForm(){
    var cb=document.querySelector('[data-cl-price-optin-checkbox]');
    if(!cb) return;
    cb.addEventListener('change', function(){
      _state.checked = cb.checked;
      applyPriceState();
    });
    if(cb.checked){ _state.checked = true; applyPriceState(); }
    document.addEventListener('submit', function(e){
      var form=e.target;
      if(!form || !form.matches || !form.matches('form[id^="product_form_"]')) return;
      if(!cb.checked) return;
      var input=document.createElement('input');
      input.type='hidden';
      input.name='attributes[_cl_p02_price_arm]';
      input.value='B-optin';
      form.appendChild(input);
    }, true);
  }

    function fire(arm){
      // Delegates to the shared helper which handles:
      //   - cro_test_<id>=<arm> cart attribute
      //   - dataLayer.push (unconditional)
      //   - gtag('event','ab_test_exposure') with 5s retry
      //   - stix.track.exposeTest (Klaviyo + TW)
      // Helper is idempotent per (testId, arm), so safe to invoke twice
      // (once right after assignment, once from the legacy call site).
      if (typeof window.stixCroExpose === 'function') {
        window.stixCroExpose(TEST_ID, arm, { page_type: 'pdp' });
        return;
      }
      // Inline fallback if stix-cro-expose.js failed to load.
      try {
        (window.dataLayer = window.dataLayer || []).push({
          event: 'ab_test_exposure', cl_test_id: TEST_ID, cl_test_variant: arm,
          page_type: 'pdp', page_path: location.pathname
        });
      } catch (e) {}
      try {
        fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: 'attributes[cro_test_' + TEST_ID + ']=' + encodeURIComponent(arm),
          credentials: 'same-origin', keepalive: true
        }).catch(function(){});
      } catch (e) {}
    }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
